import config from '../config';
import { clampTextToDimensions } from '../utils';

const POWER_UPS = [config.ARMOR, config.MAGNET, config.BOOSTER, config.ANTACID];
const AD = 'Adverstisement';

let soundManager;
let dataManager;
let apiManager;

class Store extends Phaser.Scene {
  init () {
    let g = this;

    g.transitionActive = true;
    soundManager = g.scene.get('SoundManager');
    dataManager = g.sys.game.dataManager;
  }
  create () {
    let g = this;

    g.events.off('resume');
    g.events.on('resume', (a, data) => {
      console.log('On Store Resume!');
      soundManager.resumeMusic();
    });

    let bg = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'overlay-bg');
    bg.setAlpha(0.9);

    let group = [];
    let panelX = -config.WIDTH / 2;
    
    let storeText = g.add.text(panelX, config.CENTER_Y - 400, g.game.localisationManager.GetString("begin_powerup"), { fontFamily: "FredBurger Black", fontSize: (40) +"px", color: "#000", align: 'center' })
    storeText.setOrigin(0.5);
    clampTextToDimensions(storeText, g.scale.width, 200);
    group.push(storeText);

    let coin = g.add.sprite(panelX - 13, config.CENTER_Y - 335, 'store-sprite');
    coin.setFrame('coin.png');
    coin.setOrigin(1, 0.5);
    group.push(coin);

    let coinValue = dataManager.getCoins();
    
    let coinCount = g.add.text(panelX - 13, coin.y, g.game.localisationManager.language != "ar" ? coinValue.toLocaleString(g.game.localisationManager.language) : coinValue, { fontFamily: "FredBurger Black", fontSize: (44) +"px", color: "#fcbd19", align: 'center' })
    coinCount.setOrigin(0, 0.5);
    coinCount.setStroke('#FFF', 12);
    group.push(coinCount);

    // ARMOR PANEL
    let armor = g.add.sprite(panelX - 158, config.CENTER_Y - 140, 'store-sprite');
    armor.setFrame('armor.png');
    armor.powerUp = config.ARMOR;
    armor.cost = config.ARMOR_COST;
    armor.setInteractive();
    armor.on('pointerdown', onPowerUpClick);
    
    let priceText = g.add.text(armor.x, armor.y + 56, config.ARMOR_COST, { fontFamily: "FredBurger Black", fontSize: (33) +"px", color: "#000", align: 'center' })
    priceText.setOrigin(0, 0.5);
    group.push(priceText);
    
    armor.priceText = priceText;
    let armorText = g.add.text(armor.x, armor.y - 95, g.game.localisationManager.GetString("armor"), { fontFamily: "FredBurger Black", fontSize: (24) +"px", color: "#000", align: 'center' })
    armorText.setOrigin(0.5);
    clampTextToDimensions(armorText, 270, 100);
    let lock = g.add.sprite(armor.x, armor.y, 'store-sprite');
    lock.setFrame('lock.png');
    armor.lock = lock;
    group.push(armor);
    group.push(priceText);
    group.push(armorText);
    group.push(lock);

    // MAGNET PANEL
    let magnet = g.add.sprite(panelX + 158, config.CENTER_Y - 140, 'store-sprite');
    magnet.setFrame('magnet.png');
    magnet.powerUp = config.MAGNET;
    magnet.cost = config.MAGNET_COST;
    magnet.setInteractive();
    magnet.on('pointerdown', onPowerUpClick);
    priceText = g.add.text(magnet.x, magnet.y + 56, config.MAGNET_COST, { fontFamily: "FredBurger Black", fontSize: (33) +"px", color: "#000", align: 'center' })
    priceText.setOrigin(0, 0.5);
    magnet.priceText = priceText;
    let magnetText = g.add.text(magnet.x, magnet.y - 95, g.game.localisationManager.GetString("magnet"), { fontFamily: "FredBurger Black", fontSize: (24) +"px", color: "#000", align: 'center' })
    magnetText.setOrigin(0.5);
    clampTextToDimensions(magnetText, 270, 100);
    lock = g.add.sprite(magnet.x, magnet.y, 'store-sprite');
    lock.setFrame('lock.png');
    magnet.lock = lock;
    group.push(magnet);
    group.push(priceText);
    group.push(magnetText);
    group.push(lock);
    
    // BOOSTER PANEL
    let booster = g.add.sprite(panelX - 158, config.CENTER_Y + 180, 'store-sprite');
    booster.setFrame('booster.png');
    booster.powerUp = config.BOOSTER;
    booster.cost = config.BOOSTER_COST;
    booster.setInteractive();
    booster.on('pointerdown', onPowerUpClick);
    priceText = g.add.text(booster.x, booster.y + 56, config.BOOSTER_COST, { fontFamily: "FredBurger Black", fontSize: (33) +"px", color: "#000", align: 'center' })
    priceText.setOrigin(0, 0.5);
    booster.priceText = priceText;
    let boosterText = g.add.text(booster.x, booster.y - 95, g.game.localisationManager.GetString("score_booster"), { fontFamily: "FredBurger Black", fontSize: (24) +"px", color: "#000", align: 'center' })
    boosterText.setOrigin(0.5);
    clampTextToDimensions(boosterText, 270, 100);
    lock = g.add.sprite(booster.x, booster.y, 'store-sprite');
    lock.setFrame('lock.png');
    booster.lock = lock;
    group.push(booster);
    group.push(priceText);
    group.push(boosterText);
    group.push(lock);

    // ANTACID PANEL
    let antacid = g.add.sprite(panelX + 158, config.CENTER_Y + 180, 'store-sprite');
    antacid.setFrame('antacid.png');
    antacid.powerUp = config.ANTACID;
    antacid.cost = config.ANTACID_COST;
    antacid.setInteractive();
    antacid.on('pointerdown', onPowerUpClick);
    priceText = g.add.text(antacid.x, antacid.y + 56, config.ANTACID_COST, { fontFamily: "FredBurger Black", fontSize: (33) +"px", color: "#000", align: 'center' })
    priceText.setOrigin(0, 0.5);
    antacid.priceText = priceText;
    let antacidText = g.add.text(antacid.x, antacid.y - 95, g.game.localisationManager.GetString("antacid"), { fontFamily: "FredBurger Black", fontSize: (24) +"px", color: "#000", align: 'center' })
    antacidText.setOrigin(0.5);
    clampTextToDimensions(antacidText, 270, 100);
    lock = g.add.sprite(antacid.x, antacid.y, 'store-sprite');
    lock.setFrame('lock.png');
    antacid.lock = lock;
    group.push(antacid);
    group.push(priceText);
    group.push(antacidText);
    group.push(lock);

    // PLAY BTN (CENTER IF FREE BTN GETS REMOVED)
    let playBtn = g.add.sprite(panelX, config.CENTER_Y + 390, 'store-sprite');
    playBtn.setFrame('btn-play.png');
    playBtn.setInteractive();
    playBtn.on('pointerdown', () => {
      if (g.transitionActive) { return; }
      g.transitionActive = true;
      soundManager.playSound('btn-regular');
      g.tweens.add({
        targets: bg,
        alpha: 0,
        duration: 250
      });
      g.tweens.add({
        targets: group,
        x: '+=' + config.WIDTH,
        duration: 250,
        ease: 'Quad.easeOut',
        onComplete: () => {
          g.scene.stop('Store');
          // g.scene.resume(dataManager.getSessionItem(config.BASE_SCENE), { queuedPowerUp: false });
          g.scene.stop('Play');
          g.scene.start('Play', { isContinue: false, queuedPause: false, queuedPowerUp: false });
        }
      });
    });
    group.push(playBtn);

    function onPowerUpClick () {
      if (g.transitionActive) { return; }
      let coinValue = dataManager.getCoins();
      let advert = false;
      if (this.cost <= coinValue) {
        dataManager.setCoins(coinValue - this.cost);
        g.transitionActive = true;
      }
      if (g.transitionActive) {
        g.tweens.add({
          targets: bg,
          alpha: 0,
          duration: 250
        });
        g.tweens.add({
          targets: group,
          x: '+=' + config.WIDTH,
          duration: 250,
          ease: 'Quad.easeOut',
          onComplete: () => {
            g.scene.stop('Store');
            // g.scene.resume(dataManager.getSessionItem(config.BASE_SCENE), { queuedPowerUp: this.powerUp, queuedPause: false });
            g.scene.stop('Play');
            g.scene.start('Play', { isContinue: false, queuedPause: false, queuedPowerUp: this.powerUp });
          }
        });
      }
    }

    g.tweens.add({
      targets: group,
      x: '+=' + config.WIDTH,
      duration: 500,
      ease: 'Back.easeOut',
      onComplete: () => {
        g.transitionActive = false;
      }
    });

    g.assets = { armor, magnet, booster, antacid };
  }
  update () {
    let g = this;

    let coinValue = dataManager.getCoins();
    _.each(g.assets, (sprite) => {
      if (sprite.cost === AD) {
        sprite.lock.setVisible(false);
      } else {
        if (sprite.lock.active && coinValue >= sprite.cost) {
          sprite.lock.setVisible(false);
        }
      }
    });
  }
}

export default Store;
